/* eslint-disable jira/filename-case */
import {
	TAILORED_ONBOARDING_BOARD,
	TAILORED_ONBOARDING_CALENDAR,
	TAILORED_ONBOARDING_FORM,
	TAILORED_ONBOARDING_INVITE,
	TAILORED_ONBOARDING_LIST,
	TAILORED_ONBOARDING_PAGES,
	TAILORED_ONBOARDING_SUMMARY,
	TAILORED_ONBOARDING_TIMELINE,
	JWM_CREATE_PROJECT_TASK,
	JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES,
	JWM_BUILD_FORM_TASK,
	JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK,
	JWM_SUMMARY_AND_REPORTS_TASK,
	JWM_TRELLO_CROSSFLOW_TASK_IMPORT,
} from '../../../../common/constants.tsx';
import type { Cards } from '../../../../common/types.tsx';
import { Experience, TeamType } from '../tailored-onboarding/constants.tsx';

import { Experiments } from './experiments.tsx';
import { UserRole } from './user-roles.tsx';
import {
	OPS_TAILORED_ONBOARDING_TASK_VARIANTS,
	MKT_TAILORED_ONBOARDING_TASK_VARIANTS,
} from './constants.tsx';

export const TAILORED_ONBOARDING_BUSINESS_CONFIG: Cards = {
	...OPS_TAILORED_ONBOARDING_TASK_VARIANTS,
	...MKT_TAILORED_ONBOARDING_TASK_VARIANTS,
	// Trello Crossflow Cards - These take priority when trelloCrossflow experiment is active
	[JWM_CREATE_PROJECT_TASK]: {
		position: { default: 10 },
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Experiments.trelloCrossflow],
					value: true,
				},
			],
		},
	},
	[JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES]: {
		position: { default: 15 },
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Experiments.trelloCrossflow],
					value: true,
				},
			],
		},
	},
	[JWM_BUILD_FORM_TASK]: {
		position: { default: 400 },
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Experiments.trelloCrossflow],
					value: true,
				},
			],
		},
	},
	[JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK]: {
		position: { default: 425 },
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Experiments.trelloCrossflow],
					value: true,
				},
			],
		},
	},
	[JWM_SUMMARY_AND_REPORTS_TASK]: {
		position: { default: 450 },
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Experiments.trelloCrossflow],
					value: true,
				},
			],
		},
	},

	[JWM_TRELLO_CROSSFLOW_TASK_IMPORT]: {
		position: { default: 650 },
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Experiments.trelloCrossflow, UserRole.siteAdmin],
					value: true,
				},
			],
		},
	},

	// Regular Tailored Onboarding Cards - These are hidden when trelloCrossflow is active
	[TAILORED_ONBOARDING_LIST]: {
		position: { default: 0 },
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Experiments.trelloCrossflow],
					value: false,
				},
				{
					condition: [TeamType.design],
					value: true,
				},
				{
					condition: [TeamType.itSupport],
					value: true,
				},
				{
					condition: [TeamType.otherPersonal],
					value: true,
				},
				{
					condition: [TeamType.productManagement],
					value: true,
				},
				{
					condition: [TeamType.projectManagement],
					value: true,
				},
				{
					condition: [TeamType.software],
					value: true,
				},
				{
					condition: [TeamType.everythingElse],
					value: true,
				},
			],
		},
	},
	[TAILORED_ONBOARDING_SUMMARY]: {
		position: {
			default: -1,
			conditional: [
				{
					condition: [TeamType.itSupport],
					value: 100,
				},
				{
					condition: [TeamType.projectManagement],
					value: 200,
				},
			],
		},
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Experiments.trelloCrossflow],
					value: false,
				},
				{
					condition: [TeamType.itSupport],
					value: true,
				},
				{
					condition: [TeamType.projectManagement],
					value: true,
				},
			],
		},
	},
	[TAILORED_ONBOARDING_TIMELINE]: {
		position: {
			default: -1,
			conditional: [
				{
					condition: [TeamType.productManagement],
					value: 100,
				},
				{
					condition: [TeamType.projectManagement],
					value: 100,
				},
				{
					condition: [TeamType.everythingElse],
					value: 300,
				},
				{
					condition: [TeamType.software],
					value: 400,
				},
			],
		},
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Experiments.trelloCrossflow],
					value: false,
				},
				{
					condition: [TeamType.productManagement],
					value: true,
				},
				{
					condition: [TeamType.projectManagement],
					value: true,
				},
				{
					condition: [TeamType.software],
					value: true,
				},
				{
					condition: [TeamType.everythingElse],
					value: true,
				},
			],
		},
	},
	[TAILORED_ONBOARDING_BOARD]: {
		position: {
			default: -1,
			conditional: [
				{
					condition: [TeamType.design],
					value: 400,
				},
				{
					condition: [TeamType.itSupport],
					value: 200,
				},
				{
					condition: [TeamType.otherPersonal],
					value: 100,
				},
				{
					condition: [TeamType.software],
					value: 100,
				},
				{
					condition: [TeamType.everythingElse],
					value: 100,
				},
			],
		},
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Experiments.trelloCrossflow],
					value: false,
				},
				{
					condition: [TeamType.design],
					value: true,
				},
				{
					condition: [TeamType.itSupport],
					value: true,
				},
				{
					condition: [TeamType.otherPersonal],
					value: true,
				},
				{
					condition: [TeamType.software],
					value: true,
				},
				{
					condition: [TeamType.everythingElse],
					value: true,
				},
			],
		},
	},
	[TAILORED_ONBOARDING_CALENDAR]: {
		position: {
			default: -1,
			conditional: [
				{
					condition: [TeamType.design],
					value: 100,
				},
				{
					condition: [TeamType.itSupport],
					value: 400,
				},
				{
					condition: [TeamType.otherPersonal],
					value: 200,
				},
				{
					condition: [TeamType.everythingElse],
					value: 200,
				},
			],
		},
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Experiments.trelloCrossflow],
					value: false,
				},
				{
					condition: [TeamType.design],
					value: true,
				},
				{
					condition: [TeamType.itSupport],
					value: true,
				},
				{
					condition: [TeamType.otherPersonal],
					value: true,
				},
				{
					condition: [TeamType.everythingElse],
					value: true,
				},
			],
		},
	},
	[TAILORED_ONBOARDING_PAGES]: {
		position: {
			default: -1,
			conditional: [
				{
					condition: [TeamType.design],
					value: 200,
				},
				{
					condition: [TeamType.itSupport],
					value: 500,
				},
				{
					condition: [TeamType.otherPersonal],
					value: 300,
				},
				{
					condition: [TeamType.productManagement],
					value: 200,
				},
				{
					condition: [TeamType.projectManagement],
					value: 400,
				},
				{
					condition: [TeamType.software],
					value: 200,
				},
				{
					condition: [TeamType.everythingElse],
					value: 400,
				},
			],
		},
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Experience.fedRamp],
					value: false,
				},
				{
					condition: [Experiments.trelloCrossflow],
					value: false,
				},
				{
					condition: [TeamType.design],
					value: true,
				},
				{
					condition: [TeamType.itSupport],
					value: true,
				},
				{
					condition: [TeamType.otherPersonal],
					value: true,
				},
				{
					condition: [TeamType.productManagement],
					value: true,
				},
				{
					condition: [TeamType.projectManagement],
					value: true,
				},
				{
					condition: [TeamType.software],
					value: true,
				},
				{
					condition: [TeamType.everythingElse],
					value: true,
				},
			],
		},
	},
	[TAILORED_ONBOARDING_FORM]: {
		position: {
			default: -1,
			conditional: [
				{
					condition: [TeamType.design],
					value: 300,
				},
				{
					condition: [TeamType.itSupport],
					value: 300,
				},
				{
					condition: [TeamType.otherPersonal],
					value: 400,
				},
				{
					condition: [TeamType.productManagement],
					value: 300,
				},
				{
					condition: [TeamType.projectManagement],
					value: 300,
				},
				{
					condition: [TeamType.software],
					value: 300,
				},
				{
					condition: [TeamType.everythingElse],
					value: 500,
				},
			],
		},
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Experiments.trelloCrossflow],
					value: false,
				},
				{
					condition: [TeamType.design],
					value: true,
				},
				{
					condition: [TeamType.itSupport],
					value: true,
				},
				{
					condition: [TeamType.otherPersonal],
					value: true,
				},
				{
					condition: [TeamType.productManagement],
					value: true,
				},
				{
					condition: [TeamType.projectManagement],
					value: true,
				},
				{
					condition: [TeamType.software],
					value: true,
				},
				{
					condition: [TeamType.everythingElse],
					value: true,
				},
			],
		},
	},
	[TAILORED_ONBOARDING_INVITE]: {
		position: {
			default: -1,
			conditional: [
				{
					condition: [TeamType.design],
					value: 500,
				},
				{
					condition: [TeamType.itSupport],
					value: 600,
				},
				{
					condition: [TeamType.otherPersonal],
					value: 500,
				},
				{
					condition: [TeamType.productManagement],
					value: 400,
				},
				{
					condition: [TeamType.projectManagement],
					value: 500,
				},
				{
					condition: [TeamType.software],
					value: 500,
				},
				{
					condition: [TeamType.everythingElse],
					value: 600,
				},
			],
		},
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Experiments.trelloCrossflow],
					value: false,
				},
				{
					condition: [TeamType.design],
					value: true,
				},
				{
					condition: [TeamType.itSupport],
					value: true,
				},
				{
					condition: [TeamType.otherPersonal],
					value: true,
				},
				{
					condition: [TeamType.productManagement],
					value: true,
				},
				{
					condition: [TeamType.projectManagement],
					value: true,
				},
				{
					condition: [TeamType.software],
					value: true,
				},
				{
					condition: [TeamType.everythingElse],
					value: true,
				},
			],
		},
	},
};
